import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';

interface Props {
    open: boolean;
    setOpen: (open:boolean) => void;
}

export const CounselorInviteAlertDialog = (props: Props) => {
    const handleClose = () => {
        props.setOpen(false);
    };

return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Counselor Already Invited</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          It seems you already have a counselor you’re working with. You can only invite one counselor to collaborate.
          If you'd like to change the counselor, please remove your current one and add a new one.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default CounselorInviteAlertDialog;